import { OrgCfgSchemaTypes } from "@bfc-software/api-schemas";
import { LocalStorage, logger } from "@bfc-software/app-toolbox";
import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";

/**
 * org_config.yaml declares this service's auth as `X-CLIENT-CODE` (apiKey),
 * not the `Authorization: Bearer` scheme every other service client in this
 * app uses -- the config service does not read an Authorization header at
 * all, so the AAA session JWT goes in X-CLIENT-CODE instead.
 */
const fetchClient = () => {
  const token = LocalStorage.getGlobalJwt();
  const baseUrl = `${getEnv().orgCfgServiceBase}/orgs/config/v1`;

  logger.info(`Building org config api client against '${baseUrl}'`);

  return createFetchClient<OrgCfgSchemaTypes.paths>({
    baseUrl,
    credentials: "include",
    headers: {
      ...(token ? { "X-CLIENT-CODE": token } : {}),
    },
  });
};

export const apiClient = () => createClient(fetchClient());

/** Raw fetch client for callers that need the response status itself (a 404 here means "no settings saved yet", not a failure). */
export const rawFetchClient = () => fetchClient();
